import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import {
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import { entityWarningContent } from './EntityWarningContent';
import { useEntity } from '@backstage/plugin-catalog-react';
import { PropsWithChildren } from 'react';

// TODO: If there's no entity, then we go get it from the api...
// production environments just sit where they are in an environment tab.

// Can we override the route here?

const cloudEnvOverviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} relations={['hasApp']} />
    </Grid>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);

const cloudEnvEntityPage = (
  
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {cloudEnvOverviewContent}
    </EntityLayout.Route>
  </EntityLayout>

);

const CloudEnvCase = ({ children }: PropsWithChildren) => {

    const { entity } = useEntity();

    if (
        entity.kind === 'CloudEnv'
    ) {
        return <>{children}</>;
    }
    return null;
};

export const cloudEnvPage = (
    <EntitySwitch>

        <EntitySwitch.Case>
            <CloudEnvCase>
                {cloudEnvEntityPage}
            </CloudEnvCase>
        </EntitySwitch.Case>

        <EntitySwitch.Case>
            <h1>Unknown entity type</h1>
        </EntitySwitch.Case>
        
    </EntitySwitch>
);